import React from 'react';
import MatchTeamEvents from './MatchTeamEvents';
import { hasVisibleMatchEvents } from '../utils/matchEvents';
import './MatchEventsSection.css';

/**
 * Goal / card timeline row below teams & scores so event lists do not shift the match header layout.
 *
 * @param {{ game: Record<string, unknown>, withCenterAugment?: boolean }} props
 */
export default function MatchEventsSection({ game, withCenterAugment = false }) {
  if (!hasVisibleMatchEvents(game)) return null;

  return (
    <div
      className={`game-match-events${withCenterAugment ? ' game-match-events--with-center-augment' : ''}`}
      aria-label="Match events"
    >
      <div className="game-match-events__side game-match-events__side--home">
        <MatchTeamEvents game={game} side="home" />
      </div>
      <div className="game-match-events__center" aria-hidden="true" />
      <div className="game-match-events__side game-match-events__side--away">
        <MatchTeamEvents game={game} side="away" />
      </div>
    </div>
  );
}
